import Branding from './setup'

/**
 *
 */
export default Branding
